import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { PAGE_SIZES, type PageSize } from './use-list-params';

/**
 * How many rows a list shows at a time: 10, 25 or 50 (decision 182, U6). A native `<select>` with
 * a visible label and a 44 px target (U16).
 */
export function PageSizeSelect({
  value,
  onChange,
}: {
  readonly value: PageSize;
  readonly onChange: (size: PageSize) => void;
}) {
  const { t } = useTranslation('common');
  const id = useId();
  return (
    <div className="flex items-center gap-2">
      <label htmlFor={id} className="text-muted-foreground text-sm">
        {t('list.pageSize')}
      </label>
      <select
        id={id}
        value={value}
        onChange={(event) => onChange(Number(event.target.value) as PageSize)}
        className="border-input bg-background focus-visible:ring-ring min-h-11 rounded-md border px-3 text-sm focus-visible:ring-2 focus-visible:outline-none"
      >
        {PAGE_SIZES.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
    </div>
  );
}
